// import BillTable from "./BillTable";
// import Foodtable from "./Foodtable";
// import BeverageTable from "./BeverageTable";
// import GroupTable from "./GroupTable";
// import { useState } from "react";

// const BillShowTable = ({
//   isOrder,
//   food,
//   beverage,
//   foodGroup,
//   beverageGroup,
//   order,
//   totalInfo,
//   selected,
//   token,
//   FoodBeverageSum,
//   startDate,
//   endDate,
//   url,
//   setBillno
// }) => {
//   const [excludeComplementary, setExcludeComplementary] = useState(true);
//   const [onlyComplementary, setOnlyComplementary] = useState(false);

//   return (
//     <div className="bill-tables relative mt-6">
//       <BillTable
//         isOrder={isOrder}
//         order={order}
//         totalInfo={totalInfo}
//         selected={selected}
//         token={token}
//         url={url}
//         setBillno={setBillno}
//         selectedOutlet={selected}
//         startDate={startDate}
//         endDate={endDate}
//         excludeComplementary={excludeComplementary}
//         setExcludeComplementary={setExcludeComplementary}
//         onlyComplementary={onlyComplementary}
//         setOnlyComplementary={setOnlyComplementary}
//       />

//       <div className="food-beverage-table-width">
//         <div className="food-beverage-table">
//           <Foodtable
//             food={food}
//             FoodBeverageSum={FoodBeverageSum}
//             outlet={selected}
//             startDate={startDate}
//             endDate={endDate}
//             token={token}
//             url={url}
//             excludeComplementary={excludeComplementary}
//             onlyComplementary={onlyComplementary}
//           />
//           <BeverageTable
//             beverage={beverage}
//             FoodBeverageSum={FoodBeverageSum}
//             outlet={selected}
//             startDate={startDate}
//             endDate={endDate}
//             token={token}
//             url={url}
//             excludeComplementary={excludeComplementary}
//             onlyComplementary={onlyComplementary}
//           />
//         </div>
//       </div>

//       <div className="group-table-width">
//         <GroupTable
//           Group={foodGroup}
//           title={"Food"}
//           itemDetails={food}
//           excludeComplementary={excludeComplementary}
//           onlyComplementary={onlyComplementary}
//         />
//         <GroupTable
//           Group={beverageGroup}
//           title={"Beverage"}
//           itemDetails={beverage}
//           excludeComplementary={excludeComplementary}
//           onlyComplementary={onlyComplementary}
//         />
//       </div>
//     </div>
//   );
// };

// export default BillShowTable;












import BillTable from "./BillTable";
import GroupTable from "./GroupTable";
import { useState } from "react";
import ItemTable from "./ItemTable";

const BillShowTable = ({
  isOrder,
  food,
  beverage,
  foodGroup,
  beverageGroup,
  order,
  totalInfo,
  selected,
  token,
  FoodBeverageSum,
  startDate,
  endDate,
  url,
  setBillno,
  handleBillNumber,
  discountData,
}) => {
  const [excludeComplementary, setExcludeComplementary] = useState(true);
  const [onlyComplementary, setOnlyComplementary] = useState(false);

  const summaryFoodQuantity = onlyComplementary
    ? Number(FoodBeverageSum?.complementaryFoodQuantity || 0)
    : excludeComplementary
      ? Number(FoodBeverageSum?.foodquantity || 0)
      : Number(FoodBeverageSum?.foodquantity || 0) +
      Number(FoodBeverageSum?.complementaryFoodQuantity || 0);

  const summaryFoodTotal = onlyComplementary
    ? Number(FoodBeverageSum?.complementaryFoodTotal || 0)
    : excludeComplementary
      ? Number(FoodBeverageSum?.foodtotal || 0)
      : Number(FoodBeverageSum?.foodtotal || 0) +
      Number(FoodBeverageSum?.complementaryFoodTotal || 0);

  const summaryBeverageQuantity = onlyComplementary
    ? Number(FoodBeverageSum?.complementaryBeverageQuantity || 0)
    : excludeComplementary
      ? Number(FoodBeverageSum?.beveragequantity || 0)
      : Number(FoodBeverageSum?.beveragequantity || 0) +
      Number(FoodBeverageSum?.complementaryBeverageQuantity || 0);

  const summaryBeverageTotal = onlyComplementary
    ? Number(FoodBeverageSum?.complementaryBeverageTotal || 0)
    : excludeComplementary
      ? Number(FoodBeverageSum?.beveragetotal || 0)
      : Number(FoodBeverageSum?.beveragetotal || 0) +
      Number(FoodBeverageSum?.complementaryBeverageTotal || 0);

  return (
    <div className="bill-tables relative mt-6">
      <BillTable
        isOrder={isOrder}
        order={order}
        totalInfo={totalInfo}
        selected={selected}
        token={token}
        url={url}
        setBillno={setBillno}
        selectedOutlet={selected}
        startDate={startDate}
        endDate={endDate}
        excludeComplementary={excludeComplementary}
        setExcludeComplementary={setExcludeComplementary}
        onlyComplementary={onlyComplementary}
        setOnlyComplementary={setOnlyComplementary}
        handleBillNumber={handleBillNumber}
      />

      <div className="grid grid-cols-2 gap-9 px-2.5 my-9">
        <ItemTable
          type="food"
          items={food}
          FoodBeverageSum={FoodBeverageSum}
          outlet={selected}
          startDate={startDate}
          endDate={endDate}
          token={token}
          url={url}
          excludeComplementary={excludeComplementary}
          onlyComplementary={onlyComplementary}
          summaryQuantity={summaryFoodQuantity}
          summaryTotal={summaryFoodTotal}
          discountData={discountData}
        />
        <ItemTable
          type="beverage"
          items={beverage}
          FoodBeverageSum={FoodBeverageSum}
          outlet={selected}
          startDate={startDate}
          endDate={endDate}
          token={token}
          url={url}
          excludeComplementary={excludeComplementary}
          onlyComplementary={onlyComplementary}
          summaryQuantity={summaryBeverageQuantity}
          summaryTotal={summaryBeverageTotal}
          discountData={discountData}
        />
      </div>

      <div className="grid grid-cols-2 gap-9 px-2.5">
        <GroupTable
          Group={foodGroup}
          title={"Food"}
          itemDetails={food}
          excludeComplementary={excludeComplementary}
          onlyComplementary={onlyComplementary}
          summaryQuantity={summaryFoodQuantity}
          summaryTotal={summaryFoodTotal}
        />
        <GroupTable
          Group={beverageGroup}
          title={"Beverage"}
          itemDetails={beverage}
          excludeComplementary={excludeComplementary}
          onlyComplementary={onlyComplementary}
          summaryQuantity={summaryBeverageQuantity}
          summaryTotal={summaryBeverageTotal}
        />
      </div>
    </div>
  );
};

export default BillShowTable;
